import { render, staticRenderFns } from "./InputBlockChainAddress.vue?vue&type=template&id=f9b74d9e&scoped=true"
import script from "./InputBlockChainAddress.vue?vue&type=script&lang=js"
export * from "./InputBlockChainAddress.vue?vue&type=script&lang=js"
import style0 from "./InputBlockChainAddress.vue?vue&type=style&index=0&id=f9b74d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b74d9e",
  null
  
)

export default component.exports